/*
 * Variant-specific FAQ groups.
 *
 * snippets/faq-variant-groups.liquid server-renders one accordion group per
 * distinct FAQ list on the product, each tagged with a signature. This file
 * picks which one is visible.
 *
 * Every group is in the DOM up front, so switching fabric or colour swaps the
 * FAQs with no fetch and no loading state. The section's own accordion blocks
 * are the fallback: a variant with FAQs of its own shows its group in their
 * place, and a variant absent from the map (merchants only fill the metafield
 * where FAQs differ) shows the blocks.
 *
 * Listens on `variant:change`, the PDP-wide convention dispatched by
 * component-configuration-picker-v2.js and read by the sticky ATC, gallery and
 * addons components.
 */
(function () {
  'use strict';

  function parseMap(root) {
    var node = root.querySelector('[data-faq-variant-map]');
    if (!node) return {};

    var pairs;
    try {
      pairs = JSON.parse(node.textContent);
    } catch (e) {
      return {};
    }
    if (!Array.isArray(pairs)) return {};

    // Entries are "<variantId>:<signature>". Signatures are metaobject handles
    // joined by "-", so they never contain a colon; split on the first one only.
    return pairs.reduce(function (map, pair) {
      var split = String(pair).indexOf(':');
      if (split > 0) map[String(pair).slice(0, split)] = String(pair).slice(split + 1);
      return map;
    }, {});
  }

  function show(root, signature) {
    var groups = root.querySelectorAll('[data-faq-group]');
    var target = null;

    for (var i = 0; i < groups.length; i++) {
      if (groups[i].getAttribute('data-faq-group') === signature) target = groups[i];
    }

    // An unknown or missing signature means this variant has no FAQs of its
    // own, so every group hides and the section's blocks show instead.
    for (var j = 0; j < groups.length; j++) {
      groups[j].hidden = groups[j] !== target;
    }

    var fallback = root.querySelector('[data-faq-fallback]');
    if (fallback) fallback.hidden = !!target;
  }

  function currentVariantId(root) {
    var param = new URLSearchParams(window.location.search).get('variant');
    if (param) return String(param);

    // No ?variant= in the URL is the normal landing case. Shopify has still
    // picked a variant, and the snippet records it, so use that rather than
    // treating the variant as unknown — which would drop the page onto the
    // fallback blocks even when the selected variant has its own FAQs.
    var node = root.querySelector('[data-faq-initial-variant]');
    if (!node) return null;
    try {
      var id = JSON.parse(node.textContent);
      return id ? String(id) : null;
    } catch (e) {
      return null;
    }
  }

  function init(root) {
    if (root.dataset.faqVariantReady === 'true') return;
    root.dataset.faqVariantReady = 'true';

    var map = parseMap(root);

    function sync(id) {
      show(root, id ? map[String(id)] : undefined);
    }

    // Resolve the initial group before any picker has dispatched its first
    // event. The snippet already server-rendered this same choice; re-running
    // it here keeps the two in step if the URL names a different variant.
    sync(currentVariantId(root));

    document.addEventListener('variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      sync(variant && variant.id);
    });
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-faq-variant-groups]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // The theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
